import React from 'react'

export const MainLayout = ({children}) => {
  return (
    <div style={{display:"flex", flexDirection:"column", alignItems:"center"}}>
        {children}
    </div>
  )
}
